import { DrawerContentComponentProps } from '@react-navigation/drawer';
import React, { useEffect, useState } from 'react';
import { FlatList, Platform } from 'react-native';
import styled from 'styled-components/native';
import Spacer from '../../components/Spacer';
import { Caption } from '../../components/Typography';
import Colors from '../../constants/Colors';
import AppVersionInfo from '../../components/AppVersionInfo';

const StyledSafeAreaView = styled.SafeAreaView`
  height: 100%;
`;

const drawerList = [
  // {
  //   label: 'Home',
  //   screenName: 'HomeNav'
  // },
  {
    label: 'Today',
    screenName: 'ToDoNav'
  },
  {
    label: 'Join',
    screenName: 'DiscoverNav'
  },
  {
    label: 'My Studies',
    screenName: 'StudiesNav'
  },
  {
    label: 'My Data',
    screenName: 'MyDataNav'
  },
  {
    label: 'Messages',
    screenName: 'MessengerNav'
  },
  {
    label: 'Profile',
    screenName: 'MyProfileSettingsNav'
  }
  // {
  //   label: 'Back to Welcome Survey',
  //   subLabel: 'Welcome Survey',
  //   screenName: 'WelcomeSurveyScreen'
  // }
  // {
  //   label: 'Example 2',
  //   subLabel: 'Survey Form Date Input',
  //   screenName: 'SurveyFormDateInputExample'
  // },
  // {
  //   label: 'Example 3',
  //   subLabel: 'Survey Form Select',
  //   screenName: 'SurveyFormSelectExample'
  // },
  // {
  //   label: 'Example 4',
  //   subLabel: 'Study Survey Input',
  //   screenName: 'SurveyFormInputExample'
  // },
  // {
  //   label: 'Example 5',
  //   subLabel: 'Survey Form Multiple Choice',
  //   screenName: 'SurveyFormMultipleChoiceExample'
  // },
  // {
  //   label: 'Example 6',
  //   subLabel: 'Survey Form Slider',
  //   screenName: 'SurveyFormSliderExample'
  // },
  // {
  //   label: 'Sample Consent',
  //   subLabel: 'Consent Screen',
  //   screenName: 'ConsentScreen'
  // },
  // {
  //   label: 'Survey #1',
  //   subLabel: 'Pre-screening',
  //   screenName: 'PreScreeningSurvey'
  // },
  // {
  //   label: 'Survey #2',
  //   subLabel: 'Intake Survey',
  //   screenName: 'IntakeSurvey'
  // },
  // {
  //   label: 'Survey #3',
  //   subLabel: 'Demographics and Medical History Survey',
  //   screenName: 'DemographicsAndMedicalHistorySurvey'
  // },
  // {
  //   label: 'Survey #4',
  //   subLabel: 'Medical Outcomes Study Sleep Scale (MOSSS) Survey',
  //   screenName: 'MedicalOutcomesStudySleepScaleSurvey'
  // },
  // {
  //   label: 'Survey #5',
  //   subLabel: 'Generalized Anxiety Disorder-7 (GAD-7) Survey',
  //   screenName: 'GeneralizedAnxietyDisorderSurvey'
  // },
  // {
  //   label: 'Survey #6',
  //   subLabel: 'Insomnia Severity Index (ISI)',
  //   screenName: 'InsomniaSeverityIndexSurvey'
  // },
  // {
  //   label: 'Survey #7',
  //   subLabel: 'Study Dose',
  //   screenName: 'StudyDoseSurvey'
  // },
  // {
  //   label: 'Survey #8',
  //   subLabel: 'Exit Survey',
  //   screenName: 'ExitSurvey'
  // }

  // {
  //   label: 'Gauge Chart',
  //   subLabel: 'Example',
  //   screenName: 'GaugeChartScreen'
  // },
  // {
  //   label: 'Data Tracker Chart',
  //   subLabel: 'Example Screen',
  //   screenName: 'DataTrackerChartScreen'
  // },
  // {
  //   label: 'Compare Chart',
  //   subLabel: 'Example Screen',
  //   screenName: 'CompareChartScreen'
  // },
  // {
  //   label: 'Calendar',
  //   subLabel: 'Example',
  //   screenName: 'CalendarScreen'
  // },
  // {
  //   label: 'Sleep: Study 1',
  //   subLabel: 'Name: Rosalind Franklin \nIntervention: Vitamin C',
  //   screenName: 'SleepStudyResultsExampleScreen',
  //   studyNumber: 1
  // },
  // {
  //   label: 'Sleep: Study 2',
  //   subLabel: 'Name: Rosalind Franklin \nIntervention: Sleep Z Gummy',
  //   screenName: 'SleepStudyResultsExampleScreen',
  //   studyNumber: 2
  // },
  // {
  //   label: 'Sleep: Study 1 (No Change)',
  //   subLabel: 'Name: Sleepy Sue \nIntervention: Sleep Z Gummy',
  //   screenName: 'SleepStudyResultsExampleScreen',
  //   studyNumber: 3
  // },
  // {
  //   label: 'Sleep: Study 2 (Variable)',
  //   subLabel: 'Name: Sleepy Sue \nIntervention: Sleep Z Gummy',
  //   screenName: 'SleepStudyResultsExampleScreen',
  //   studyNumber: 4
  // },
  // {
  //   label: 'Sleep: Study 3 (Tight - 30)',
  //   subLabel: 'Name: Sleepy Sue \nIntervention: Sleep Z Gummy',
  //   screenName: 'SleepStudyResultsExampleScreen',
  //   studyNumber: 5
  // },
  // {
  //   label: 'Sleep: Study 4 (Tight - 60)',
  //   subLabel: 'Name: Sleepy Sue \nIntervention: Sleep Z Gummy',
  //   screenName: 'SleepStudyResultsExampleScreen',
  //   studyNumber: 6
  // },
  // {
  //   label: 'Sleep: Study 5 (Tight - neg 30)',
  //   subLabel: 'Name: Sleepy Sue \nIntervention: Sleep Z Gummy',
  //   screenName: 'SleepStudyResultsExampleScreen',
  //   studyNumber: 7
  // },
  // {
  //   label: 'Pain: Study 1',
  //   subLabel: 'Name: Painful Paul \nIntervention: Vitamin C',
  //   screenName: 'PainStudyResultsExampleScreen',
  //   studyNumber: 1
  // },
  // {
  //   label: 'Pain: Study 2',
  //   subLabel: 'Name: Painful Paul \nIntervention: ReLeaf',
  //   screenName: 'PainStudyResultsExampleScreen',
  //   studyNumber: 2
  // }

  // {
  //   label: 'Test Dynamic Form Screen',
  //   subLabel: 'Test Form',
  //   screenName: 'TestDynamicFormScreen'
  // },
  // {
  //   label: 'Gauge Chart',
  //   subLabel: 'Example',
  //   screenName: 'GaugeChartScreen'
  // },
  // {
  //   label: 'Data Tracker Chart',
  //   subLabel: 'Example Screen',
  //   screenName: 'DataTrackerChartScreen'
  // },
  // {
  //   label: 'Compare Chart',
  //   subLabel: 'Example Screen',
  //   screenName: 'CompareChartScreen'
  // },
  // {
  //   label: 'Calendar',
  //   subLabel: 'Example',
  //   screenName: 'CalendarScreen'
  // },
  // {
  //   label: 'Study 1 Result',
  //   subLabel: 'Vitamin C',
  //   screenName: 'Study1ResultsExampleScreen'
  // },
  // {
  //   label: 'Study 2 Result',
  //   subLabel: 'Sleep Z Gummy',
  //   screenName: 'Study2ResultsExampleScreen'
  // }
];

const StyledVersionInfo = styled(Caption)`
  padding: 0 16px;
`;

const StyledNavItemContainer = styled.TouchableOpacity<{ focused: boolean }>`
  padding: 15px 15px 15px 20px;
  border-left-width: ${p => (p.focused ? 7 : 0)}px;
  border-left-color: ${p => (p.focused ? Colors.primaryPurple : 'transparent')};
  border-bottom-width: 1px;
  border-bottom-color: #4d439a66;
`;
const StyledHeaderNavText = styled.Text<{ focused: boolean }>`
  font-family: ${p => (p.focused ? 'WorkSans-SemiBold' : 'WorkSans-Regular')};
  font-size: 18px;
  line-height: 20px;
  letter-spacing: -0.13px;
  color: ${Colors.primaryPurple};
`;

const DrawerScreen: React.FC<DrawerContentComponentProps> = ({
  navigation,
  state
}) => {
  const [currentScreen, setCurrentScreen] = useState<string>();
  useEffect(() => {
    if (Platform.OS !== 'web') return;

    const bottomTabRoute = state.routes.find(route => route.name === 'BottomTabNav');
    const tabState = bottomTabRoute?.state;
    if (!tabState?.routes?.length) return;

    const focusedRoute = tabState.routes[tabState.index ?? tabState.routes.length - 1];
    setCurrentScreen(focusedRoute?.name);
  }, [state]);

  const handlePress = (screenName: string) => {
    navigation.navigate('BottomTabNav', { screen: screenName });
    navigation.closeDrawer();
  };

  return (
    <StyledSafeAreaView>
      <FlatList
        data={drawerList}
        keyExtractor={item => item.label}
        renderItem={({ item }) => {
          return (
            <StyledNavItemContainer
              focused={currentScreen === item.screenName}
              activeOpacity={0.8}
              onPress={() => handlePress(item.screenName)}
            >
              <StyledHeaderNavText focused={currentScreen === item.screenName}>
                {item.label}
              </StyledHeaderNavText>
            </StyledNavItemContainer>
          );
        }}
      />
      <Spacer flexGrow />
      <Spacer size={2} />
      <AppVersionInfo />
    </StyledSafeAreaView>
  );
};

export default DrawerScreen;
